module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAKCAYAAADPcbwqAAAAwUlEQVQ4jdXSIU5DURBG4e9iCKIJiiWQIFAzhg2gCKnHsQsEgVUgEQSBxOGrx+FrWACY2oJ54oVQGkx7OW7+HHFucltE2CZVBTJzF3d4q6rbVf7OZrJ+JzMPMMMlbjLzfJXbRTAW2Bvdj5l5+JPYRXBVLTDF+zBN8JyZk+9uF8FQVXNcYDlMR3jIzDb2ugmGqnrB9Wia4mrstIjY32jVehqecDrcS5wNj9Ei4nNbZX/gA1FV8/8SDK846eoPr+EY91/6Uy18ZqNJBwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/black_right.png
// module id = OyOr
// module chunks = 1